import styled, { createGlobalStyle } from 'styled-components';
import { font, color, query, space } from '@design/templateFns';

const GlobalStyle = createGlobalStyle`
  /*
  http://meyerweb.com/eric/tools/css/reset/
  v2.0 | 20110126
  License: none (public domain)
  */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 100%;
      vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
      display: block;
  }
  body {
    font-family: var(--ev-body-font);
    ${font('body-md')}
    color: ${color('fg')};

    @media screen and (${query.below('tablet')}) {
      ${font('body-sm')}
    }
  }
  ol, ul {
      list-style: none;
  }
  blockquote, q {
      quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
      content: '';
      content: none;
  }
  table {
      border-collapse: collapse;
      border-spacing: 0;
  }


  /** Custom Below **/
  html, body {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  h1, h2, h3, h4, h5, h6, h7 {
    padding-bottom: 1rem;
  }

  h1 {
    ${font('headline-xl')}
  }

  h2 {
    ${font('headline-md')}
  }

  h3 {
    ${font('headline-sm')}
  }

  h4 {
    ${font('headline-xs')}
  }

  h5 {
    ${font('headline-xxs')}
  }

  h6 {
    ${font('headline-xxxs')}
  }

  p {
    ${font('body-lg')}
    padding-bottom: .5rem;
  }

  hr {
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-width: 1px 0 0 0;
    border-color: ${color('gray1')};
  }

  //Special Media-Gallery specific style
  .media-gallery-modal-open {
    overflow: hidden;
  }

  //Screen reader only styles from bootstrap: https://getbootstrap.com/docs/5.3/getting-started/accessibility/#visually-hidden-content
  .visually-hidden {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }
  .css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper{
   box-shadow: 0px 0px 0px 0px #43434333, 0px 8px 10px 1px #11111123, 0px 3px 14px 2px #1c1c1c1e !Important;
  }
  #menu-tag {
    /* box-shadow: 0px 0px 0px 0px #43434333, 0px 8px 10px 1px #11111123, 0px 3px 14px 2px #1c1c1c1e; */
    ul {
       padding: 0;
      }
    .MuiMenu-list {
      li {
        ${font('body-md')};
        color: ${color('gray4')};
        &:hover,
        &.Mui-selected{
          color: ${color('gray5')};
          background-color: ${color('gray1')};
        }
      }
    }
  }

  //Google usePlacesWidget styles because the item exists outside of the @components/Hero/SearchHero
  .pac-container {
    background: #fff;
    border-radius: 0 0 4px 4px;
    z-index: 1000;
  }
  .pac-item {
    padding: ${space('sm')} ${space('md')};
    color: ${color('fg')};
    ${font('body-sm-light')};
    display: flex;
    flex-wrap: nowrap;
    gap: ${space('xs')};

    @media screen and (${query.atLeast('desktop')}) {
      ${font('body-md-light')}
    }

    span {
      display: inline-block;
    }

    &:hover {
      background-color: ${color('gray1')};
      cursor: pointer;
    }
  }
    
  //Google reCAPTCHA styles
  .grecaptcha-badge {
    z-index: 1000;
  }
`;

export default GlobalStyle;

export const PlainText = styled.div`
  ol,
  ul {
    list-style: initial;
    margin-left: 1rem;
    margin-top: 0.5rem;
  }

  a {
    outline: 0;
    letter-spacing: 0.03em;
    &:hover {
      text-decoration: none;
    }

    &:focus {
      text-decoration: none;
    }
  }
`;
